import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import Waveform from "@/components/Waveform";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/account");
    else setError(res.error);
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="register-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md">
        <p className="eyebrow mb-3">Join the movement</p>
        <h1 className="font-anton uppercase text-5xl sm:text-6xl leading-none mb-8">Create account</h1>
        <Waveform color="rgb(var(--graphite))" className="mb-10" />
        <form onSubmit={submit} className="space-y-6" data-testid="register-form">
          <div>
            <label className="eyebrow block mb-2">Name</label>
            <input required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name"
              className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
          </div>
          <div>
            <label className="eyebrow block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email"
              className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
          </div>
          <div>
            <label className="eyebrow block mb-2">Password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password"
              className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
          </div>
          {error && <p className="text-destructive font-mono text-xs" data-testid="register-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="register-submit" className="btn-pulse w-full disabled:opacity-60">
            {loading ? "Creating…" : "Create Account"}
          </button>
        </form>
        <p className="mt-8 text-graphite text-sm font-mono">
          Have an account? <Link to="/login" className="text-chalk hover:text-pulse link-underline">Sign in</Link>
        </p>
      </motion.div>
    </div>
  );
}
